import React, { useState, useCallback } from 'react';
import { useLens } from './LensProvider';

const feedbackText = (event) => {
  const type = event.affordanceType || 'stabilize';
  const axis = (event.axis || event.domain?.[0] || 'system').replace('I.', '');
  switch (type) {
    case 'expand': return `${axis} capacity expanded slightly.`;
    case 'reduce': return `${axis} strain reduced.`;
    case 'redirect': return `Intent shifted toward ${axis}.`;
    case 'stabilize': return `${axis} dimension stabilized.`;
    default: return 'The aperture shifted.';
  }
};

export const EventAffordancePanel = () => {
  const { surfacedEvents, setHoveredEvent, resolveEvent, pressure } = useLens();
  const [feedback, setFeedback] = useState(null);

  const handleResolve = useCallback((event) => {
    const prevPressure = pressure;
    resolveEvent(event);
    const direction = prevPressure > 0.5 ? 'Pressure may have shifted.' : '';
    setFeedback({
      text: feedbackText(event),
      detail: direction,
      timestamp: Date.now(),
    });
    setTimeout(() => setFeedback(null), 3000);
  }, [resolveEvent, pressure]);

  return (
    <div className="event-affordance-panel">
      <h3>Event Affordances</h3>
      <p style={{ fontSize: '0.75rem', color: 'var(--text-dim)', margin: '0 0 8px', fontStyle: 'italic', borderLeft: '2px solid var(--border)', paddingLeft: '10px' }}>
        These aren't predictions — they're possibilities the field is emphasizing given your current aperture.
      </p>

      {feedback && (
        <div className="event-feedback">
          <span className="event-feedback-text">{feedback.text}</span>
          {feedback.detail && <span className="event-feedback-detail"> {feedback.detail}</span>}
        </div>
      )}

      {(!surfacedEvents || surfacedEvents.length === 0) ? (
        <p style={{ color: 'var(--text-dim)', fontSize: '0.85rem' }}>
          No significant event affordances at this configuration.
        </p>
      ) : (
        <ul>
          {surfacedEvents.map(event => (
            <li
              key={event.id}
              className="event-item"
              onMouseEnter={() => setHoveredEvent(event)}
              onMouseLeave={() => setHoveredEvent(null)}
              onClick={() => handleResolve(event)}
            >
              <strong>{event.category}</strong>
              <p>{event.description}</p>
              <div className="event-details">
                <span>Intensity: {event.intensity.toFixed(2)}</span>
                <span style={{ margin: '0 8px' }}>|</span>
                <span>Resonance: {event.resonance.toFixed(2)}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
